var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2869 10.5C16.3655 10.5 9.94391 17.4599 9.94391 26.0455C9.94391 34.631 16.3655 41.5909 24.2869 41.5909C32.2083 41.5909 38.6299 34.631 38.6299 26.0455C38.6299 17.4599 32.2083 10.5 24.2869 10.5ZM5.79199 26.0455C5.79199 14.9747 14.0725 6 24.2869 6C34.5014 6 42.7818 14.9747 42.7818 26.0455C42.7818 30.7702 41.2736 35.1132 38.7506 38.5397L49.4711 50.159C50.2818 51.0377 50.2818 52.4623 49.4711 53.341C48.6604 54.2197 47.346 54.2197 46.5353 53.341L35.8147 41.7217C32.6533 44.4563 28.6462 46.0909 24.2869 46.0909C14.0725 46.0909 5.79199 37.1163 5.79199 26.0455Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.61ef44ac9775fd3cce86b9d4d1ff2ea6.svg";
export { ForwardRef as ReactComponent };